/*
 * @Author: Filip Mateasko, DHI  
 * @Date: 2022-07-19 09:19:24 
 * @ Modified by: Filip Mateasko
 * @ Modified time: 2024-03-26 13:09:48
 */
export interface IEnvironment {
    URL_NAME: string;
    CLIENT_ID: string;
    API_URL: string;
    API_CLIENT_ID: string;
    APP_INSIGHTS_CONN_STRING: string;

}

export interface IEnvironments {
    [key: string]: IEnvironment;
}


export const Environments: IEnvironments = {
    dev: {
        URL_NAME: 'dev',
        CLIENT_ID: 'f05e7c11-0557-4dad-8922-871a31c16299',
        API_URL: ' https://dhi-downloads-webapi-dev.azurewebsites.net',
        API_CLIENT_ID: '661608b3-0fbd-4dc5-9a2a-0f3329f216b5',
        APP_INSIGHTS_CONN_STRING: 'InstrumentationKey=7d78b0d0-8b32-4609-8b41-26ea95f3faa6;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/',
    },
    local: {
        URL_NAME: 'local',
        CLIENT_ID: 'f05e7c11-0557-4dad-8922-871a31c16299',
        API_URL: 'http://localhost:36668',
        API_CLIENT_ID: '661608b3-0fbd-4dc5-9a2a-0f3329f216b5',
        APP_INSIGHTS_CONN_STRING: 'InstrumentationKey=7d78b0d0-8b32-4609-8b41-26ea95f3faa6;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/',
    },
    live: {
        URL_NAME: 'live',
        CLIENT_ID: '25143fb6-c8b5-482b-a0a3-b3724e96a122',
        API_URL: 'https://dhi-downloads-webapi.azurewebsites.net',
        API_CLIENT_ID: '082d1dc3-9739-49a9-ab3f-902dbfbbd8a1',
        APP_INSIGHTS_CONN_STRING: 'InstrumentationKey=37c61b17-9491-4668-b9de-36413774bbfd;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/',
    }

} as const;
